import { FC } from 'react';
import { CustomTag } from './Tag.style';
interface Props {
  text: string;
  textColor?: string;
  bgColor?: string;
  borderColor?: string;
}
const TagComponent: FC<Props> = ({
  text,
  textColor,
  bgColor,
  borderColor
}: Props) => {
  return <CustomTag $bgColor={bgColor} $textColor={textColor} $borderColor={borderColor}>
            {text}
        </CustomTag>;
};
export default TagComponent;